import axios from "axios";

export default function updateIntegrationSetting(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/account/api/v1/dksh-integration-setting/update`, {
        uuid: parameters.uuid,
        settings: parameters.settings,
        phase_settings: parameters.phase_settings,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
